import { render, staticRenderFns } from "./Invoiceonlinedistribution.vue?vue&type=template&id=5d948af5&scoped=true&"
import script from "./Invoiceonlinedistribution.vue?vue&type=script&lang=js&"
export * from "./Invoiceonlinedistribution.vue?vue&type=script&lang=js&"
import style0 from "./Invoiceonlinedistribution.vue?vue&type=style&index=0&id=5d948af5&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d948af5",
  null
  
)

export default component.exports